// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"addQuestion_wrapper__2G9Xr","text_ansver_box":"addQuestion_text_ansver_box__vQ29R","text_box":"addQuestion_text_box__33Zk9","imgQuiz":"addQuestion_imgQuiz__1swih"};